import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl, Tabs, Tab, ButtonGroup } from 'react-bootstrap';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import { Link } from 'react-router-dom';
import CompanyDetailPage from './CompanyDetailPage';
import { parse } from '@fortawesome/fontawesome-svg-core';
import MaskedInput from '../components/MaskedInput';
import ErrorComponent from '../components/ErrorComponent';

const roles = ["CUSTOMER_USER", "CUSTOMER_ADMIN"];
const infotype = {
  "TELEPHONE": [
    { label: "TEL_MOBILE", id: 8 },
    { label: "TEL_RESIDENTIAL", id: 7 },
    { label: "TEL_WORK", id: 9 }],
  "EMAIL": [{
    label: "EMAIL_CONTACT", id: 19
  }]
};

export default class UserDetailPage extends PageComponent {

  static PageInfo = {
    parent: CompanyDetailPage,
    hidden: true,

    path: "/Client/Detail/:id/User/:target",
    name: "menu.user",
    permission: { "CONFIGURATION_USERS_ACCESSING": true },
    icon: "user"
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.modalError = null;
    this.state.loading = true;
    this.state.isModalVisible = null;
    this.state.phone = "";
    this.state.selectedState = null;
    this.state.selectedType = null;
    this.state.form = {};
  }
  componentDidMount() {
    this.loadClients();
  }

  loadClients() {
    Connection.Secure(Connection.service + 'User/information/' + this.data.target)
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ loading: false, data: data });
          });

        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  openModal(target) {
    var t = {
      isModalVisible: target,
      modalLoading: false,
      modalError: null
    };
    if (target === "ADDRESS") {
      Connection.Secure(Connection.service + 'State/List/')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              setTimeout(() => this.setState({ states: data, modalInitializing: false }));
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      t.modalInitializing = true;
      t.selectedState = null;
    }
    t.form = {};
    this.setState(t);
  }
  savePhone() {
    Connection.Secure(Connection.service + 'User/AddInfo/' + this.data.target,
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ value: this.state.phone, valueType: { keyConstant: parseInt(this.state.selectedType) } })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.state.data.personValue.push(data);
            this.setState({ modalLoading: false, phone: "", isModalVisible: null, data: this.state.data });
          });
        else this.setState({ modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalLoading: false });
      });
    this.setState({ modalLoading: true });
  }

  saveAddress() {
    this.state.form.state = { keyConstant: parseInt(this.state.selectedState) };
    this.state.form.addressType = { keyConstant: 3 };
    Connection.Secure(Connection.service + 'User/AddAddress/' + this.data.target,
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.state.data.address.push(data);
            this.setState({ modalLoading: false, phone: "", isModalVisible: null, data: this.state.data });
          });
        else this.setState({ modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalLoading: false });
      });
    this.setState({ modalLoading: true });
  }


  saveUser() {
    this.state.form.personValue = [
      { value: this.state.form.userName, valueType: { keyConstant: 1 } },
      { value: this.state.form.email, valueType: { keyConstant: 3 } }
    ];
    Connection.Secure(Connection.service + 'User/Info/' + this.data.target,
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.state.data.criticalValue = this.state.form.criticalValue;

            for (let i = 0; i < this.state.data.personValue.length; i++) {
              const element = this.state.data.personValue[i];
              if (element.valueType.keyConstant == 1) element.value = this.state.form.userName;
              else if (element.valueType.keyConstant == 3) element.value = this.state.form.email;
            }

            this.setState({ isModalVisible: false, modalLoading: false, data: this.state.data });
          });
        else if (response.status == 409) this.setState({ isModalVisible: "alreadyuser", modalLoading: false });
        else if (response.status == 208) this.setState({ isModalVisible: "sameuser", modalLoading: false });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
    this.setState({ modalLoading: true });
  }

  deleteItem(ev, item) {
    this.setState({ isModalVisible: true, modalLoading: true });
    Connection.Secure(Connection.service + 'User/RemoveInfo/' + this.data.target + "/" + item.id,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          try {
            this.state.data.personValue.splice(this.state.data.personValue.indexOf(item), 1);
          } catch (e) {

          }
          this.setState({ modalLoading: false, isModalVisible: false, data: this.state.data });
        } else
          this.setState({ modalLoading: false, isModalVisible: false });
      })
      .catch((error) => {
        this.setState({ modalLoading: false, isModalVisible: false });
      });

    if (ev.stopPropagation) ev.stopPropagation();
    else ev.cancelBubble = true;
    (ev.preventDefault) ? ev.preventDefault() : ev.returnValue = false;
    // return false;
  }

  setForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  checkForm() {
    if (typeof this.state.form !== "object" || this.state.form == null)
      return false;
    for (var i in this.state.form)
      if (this.state.form[i] == null) {
        return false;
      }
    return true;
  }

  renderDelete(item) {
    return <div className="generics_listing_item_action" onClick={(e) => this.deleteItem(e, item)}><FontAwesomeIcon icon="times" /></div>;
  }

  renderPhone(item, icon) {
    return <div className="generics_listing_item" >
      <FontAwesomeIcon icon={icon} className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{typeof item.value === "string" && item.value.length > 0 ? item.value : "N/A"}</div>
        <div className="generics_listing_item_description" >{Labels.GetLabel("information." + item.valueType.label)}</div>
      </div>
      {
        item.valueType.keyConstant == 3 ? null :
          this.renderDelete(item)
      }
    </div>
  }

  renderInfo(target, filter, icon) {
    var d = [];
    if (this.state.data != null && Array.isArray(this.state.data.personValue))
      d = this.state.data.personValue;

    d = d.filter(filter);
    if (d.length == 0) return <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>;
    return d.map((item) => target.bind(this)(item, icon));
  }

  renderAddress(item) {
    return <div className="generics_listing_item" >
      <FontAwesomeIcon icon='map-marker-alt' className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{Parsers.parseAddress(item)}</div>
        <div className="generics_listing_item_description" >{Parsers.parseAddressCity(item)}</div>
      </div>
      {/* <div className="generics_listing_item_action" onClick={(e) => this.deleteItem(e, op, item)}><FontAwesomeIcon icon="times" /></div> */}
    </div>
  }

  renderPersonalInfo(target, label) {
    var c = GenericHelper.parseInformation(this.state.data.personValue, target, "valueType", null);
    return c == null ? null :
      <div className="generics_infobox">
        <div className="generics_infobox_label">{label}</div>
        <div className="generics_infobox_value">{c}</div>
      </div>;
  }

  render() {
    return (
      <Container context={this.constructor} props={this.data}>
        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
              <div className="generics_panels" style={{ flexDirection: "column" }}>
                <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.data.personValue, 1, "valueType"))}</span>
                  <div>{
                    this.state.data.personType.label == "EMPLOYEE" ?
                      Labels.GetLabel("generic.register") + ": " + GenericHelper.parseInformation(this.state.data.personValue, 16, "valueType", "0000000") :
                      Labels.GetLabel("information." + this.state.data.mainKeyCriticalType.label) + ": " + Parsers.parseCPF(this.state.data.criticalValue)}
                  </div>
                </div>
                <div style={{ padding: 20, flex: 1 }}>
                  {this.renderPersonalInfo(13, Labels.GetLabel("information.NAME_TITLE"))}
                  {this.renderPersonalInfo(18, Labels.GetLabel("information.DEPARTAMENT"))}
                  <div style={{ clear: "both" }}></div>
                  <div className="generic_section_header">{Labels.GetLabel('admin.email')}
                    <div className="generic_section_header_action" onClick={() => this.openModal("EMAIL")}><FontAwesomeIcon icon="plus" /></div></div>
                  {
                    this.renderInfo(this.renderPhone, (i) => i.valueType.valueTypeGroup.keyConstant == 6, 'envelope')[0]
                  } <br />
                  <div className="generic_section_header">{Labels.GetLabel('clientsnew.phone')}
                    <div className="generic_section_header_action" onClick={() => this.openModal("TELEPHONE")}><FontAwesomeIcon icon="plus" /></div></div>
                  {
                    this.renderInfo(this.renderPhone, (i) => i.valueType.valueTypeGroup.keyConstant == 2, 'phone')
                  } <br />
                </div>
                <div className="generics_actionbar">
                  {!Parsers.parsePermission2(["CONFIGURATION_USERS_EDIT"]) ? null : <DropdownButton
                    as={ButtonGroup}
                    key="up"
                    drop="up"
                    variant="primary" style={{ marginRight: 10 }}
                    title={Labels.GetLabel("program.edit")}
                    onSelect={(t) => this.openModal(t)}
                  >
                    <Dropdown.Item eventKey="info" >{Labels.GetLabel("program.info")}</Dropdown.Item>
                  </DropdownButton>}
                  <div style={{ flex: 1 }}></div>
                  {/* <Button variant="primary" style={{}} onClick={() => this.props.history.push('/Program/Detail/' + this.data.id + '/Goals')}>
                    {Labels.GetLabel("menu.programgoals")}
                  </Button> */}
                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
        }

        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible == "info" ||
            this.state.isModalVisible == "sameuser" ||
            this.state.isModalVisible == "alreadyuser"}>
          <div>
            {
              !(this.state.isModalVisible == "info" ||
                this.state.isModalVisible == "sameuser" ||
                this.state.isModalVisible == "alreadyuser") ? null :
                this.state.modalInitializing == false ?
                  this.state.isModalVisible == "sameuser" ||
                    this.state.isModalVisible == "alreadyuser" ?
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("clientdetail.edituser")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {Labels.GetLabel("program." + this.state.isModalVisible)}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                          {Labels.GetLabel("adminstategroup.closebtn")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div> :
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("clientdetail.edituser")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <MaskedInput type="fname" icon="info-circle" label={Labels.GetLabel("clientdetail.username")} notnull={true} onValid={(value) => this.setForm("userName", (value))}
                          onInvalid={(value) => this.setForm("userName", null)} value={GenericHelper.parseInformation(this.state.data.personValue, 1, "valueType")} />

                        <MaskedInput type="cpf" icon="id-card" label={Labels.GetLabel("clientdetail.usercpf")} notnull={true} onValid={(value) => this.setForm("criticalValue", (value))}
                          onInvalid={(value) => this.setForm("criticalValue", null)} value={this.state.data.criticalValue} />

                        <MaskedInput type="email" icon="envelope" label={Labels.GetLabel("clientdetail.email")} notnull={true} onValid={(value) => this.setForm("email", (value))}
                          onInvalid={(value) => this.setForm("email", null)} value={GenericHelper.parseInformation(this.state.data.personValue, 3, "valueType")} />
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                          {Labels.GetLabel("adminstategroup.closebtn")}
                        </Button>
                        <Button variant="primary" disabled={!this.checkForm()} onClick={() => this.saveUser()}>
                          {Labels.GetLabel("adminstategroup.savebtn")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
                  : <div>
                    {Labels.GetLabel("adminstategroup.saving")}
                  </div>
            }
          </div>
        </Modal>

        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible == "TELEPHONE" ||
            this.state.isModalVisible == "EMAIL"}>
          <div>
            {
              this.state.isModalVisible != null &&
                this.state.modalInitializing == false ?
                <div>
                  <Modal.Header>
                    <Modal.Title>{Labels.GetLabel("generic.newregister")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <MaskedInput type="select" icon="sitemap" label={Labels.GetLabel("generic.registertype")} notnull={true} onValid={(value) => this.setState({ selectedType: value[0] })}
                      onInvalid={(value) => this.setState({ selectedType: null })} name="id,label" parser={(t) => Labels.GetLabel("information." + t)} data={infotype[this.state.isModalVisible]} placeholder={Labels.GetLabel("generic.select")} />

                    {this.state.isModalVisible == "TELEPHONE" ?
                      <MaskedInput type="tel" icon="phone" label={Labels.GetLabel("clientdetail.newnumber")} notnull={true} onValid={(value) => this.setState({ phone: value })}
                        onInvalid={(value) => this.setState({ phone: null })} />
                      :
                      <MaskedInput type="email" icon="envelope" label={Labels.GetLabel("clientdetail.newnumber")} notnull={true} onValid={(value) => this.setState({ phone: value })}
                        onInvalid={(value) => this.setState({ phone: null })} />
                    }
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                      {Labels.GetLabel("adminstategroup.closebtn")}
                    </Button>
                    <Button variant="primary" disabled={this.state.phone == null || this.state.selectedType == null} onClick={() => this.savePhone()}>
                      {Labels.GetLabel("adminstategroup.savebtn")}
                    </Button>
                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                </div>
                : <div>
                  {Labels.GetLabel("adminstategroup.saving")}
                </div>
            }
          </div>
        </Modal>

        <Modal
          onHide={() => { }} show={this.state.isModalVisible == "ADDRESS"}>
          <div>
            {
              this.state.modalLoading == false &&
                this.state.modalInitializing == false ?
                <div>
                  <Modal.Header>
                    <Modal.Title>{Labels.GetLabel("information.ADDRESS_WORK")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group >
                      <Form.Label>{Labels.GetLabel("clientdetail.streetstate")}</Form.Label>
                      <Form.Control as="select" onChange={(item) => this.setState({ selectedState: item.currentTarget.value })} defaultValue="0">
                        <option value="0" disabled>{Labels.GetLabel("generic.select")}</option>
                        {this.state.states ?
                          this.state.states.map((item) =>
                            <option value={item.keyConstant} onSelect={() => {
                            }}>{item.description}</option>
                          ) : null}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group >
                      <Form.Label>{Labels.GetLabel("clientdetail.streetcity")}</Form.Label>
                      <Form.Control type="text" value={this.state.group} placeholder="" onChange={(text) => this.setForm("locality", text.currentTarget.value)} />
                    </Form.Group>
                    <Form.Group >
                      <Form.Label>{Labels.GetLabel("clientdetail.street")}</Form.Label>
                      <Form.Control type="text" value={this.state.group} placeholder="" onChange={(text) => this.setForm("placeName", text.currentTarget.value)} />
                    </Form.Group>
                    <Form.Group >
                      <Form.Label>{Labels.GetLabel("clientdetail.streetnumb")}</Form.Label>
                      <Form.Control type="number" value={this.state.group} placeholder="" onChange={(text) => this.setForm("placeNumber", parseInt(text.currentTarget.value))} />
                    </Form.Group>
                    <Form.Group >
                      <Form.Label>{Labels.GetLabel("clientdetail.streetcomplement")}</Form.Label>
                      <Form.Control type="text" value={this.state.group} placeholder="" onChange={(text) => this.setForm("complement", text.currentTarget.value)} />
                    </Form.Group>
                    <Form.Group >
                      <Form.Label>{Labels.GetLabel("clientdetail.streetneigh")}</Form.Label>
                      <Form.Control type="text" value={this.state.group} placeholder="" onChange={(text) => this.setForm("neighborhood", text.currentTarget.value)} />
                    </Form.Group>
                    <Form.Group >
                      <Form.Label>{Labels.GetLabel("clientdetail.streetcode")}</Form.Label>
                      <Form.Control type="text" value={this.state.group} placeholder="" onChange={(text) => this.setForm("cep", text.currentTarget.value)} />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                      {Labels.GetLabel("adminstategroup.closebtn")}
                    </Button>
                    <Button variant="primary" onClick={() => this.saveAddress()}>
                      {Labels.GetLabel("adminstategroup.savebtn")}
                    </Button>
                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                </div>
                : <div>
                  {Labels.GetLabel("adminstategroup.saving")}
                </div>
            }
          </div>
        </Modal>
      </Container>
    );


    // "street": { "EN": "Address", "PT": "Endereço" },
    // "streetnumb": { "EN": "Number", "PT": "Número" },
    // "streetcomplement": { "EN": "Complement", "PT": "Complemento" },
    // "streetneigh": { "EN": "District", "PT": "Bairro" },
    // "streetstate": { "EN": "State", "PT": "Estado" },
    // "streetcity": { "EN": "City", "PT": "Cidade" },
    // "streetcode": { "EN": "Zipcode", "PT": "CEP" },
  }
}

